import React from 'react';
import { map } from 'lodash';
import HightCharts from 'react-highcharts';
require('highcharts-exporting')(HightCharts.Highcharts);

const config = {
  chart: {
    zoomType: 'x',
  },
  title: {
    text: 'Electronic Piezometer',
  },
  subtitle: {
    text: 'Source: NDS-Cloud',
  },
  yAxis: {
    title: {
      text: 'Litre/min',
    },
  },

  xAxis: {
    type: 'category',
    labels: {
      step: 12,
      rotation: -45,
    },
  },

  legend: {
    align: 'center',
    verticalAlign: 'bottom',
  },
};

const SeepageV2Graph = ({ sensor, data: seepageData }) => {
  config.title.text = 'Seepage flow meter';

  const series = sensor.map((spec, index) => {
    return {
      name: spec.title,
      data: map(seepageData, (item) => [item.time, item.data[index]]),
    };
  });

  return <HightCharts config={{ ...config, series }} />;
};

export default SeepageV2Graph;



// WEBPACK FOOTER //
// ./resources/assets/js/components/SeepageV2Graph/index.js